import { invoiceEmailCc, invoiceEmailFrom } from '@numeo/types-main-web-app'
import { useAppSelector } from '@/hooks'
import { selectApplication, selectUser } from '@/store/authSlice'

/**
 * The address an invoice email goes from and the Cc it opens with, by the Invoices page's email dialog rule (`invoiceEmailFrom`,
 * `invoiceEmailCc`): the Invoice Settings' sender, else the user's primary connected mailbox. `from` is '' when none is connected.
 */
export const useInvoiceEmailSender = (): { from: string; defaultCc: string[] } => {
    const user = useAppSelector(selectUser)
    const application = useAppSelector(selectApplication)
    const settings = application?.temp?.accounting?.invoiceEmail
    const from = invoiceEmailFrom(settings, user?.nylasEmails, application?.integrations?.nylas?.emails)[0] ?? ''
    return { from, defaultCc: invoiceEmailCc(settings, from || undefined) }
}
